import { parse } from 'date-fns/parse';
import { format } from 'date-fns-jalali/format';
import { faIR } from 'date-fns-jalali/locale';
import type { PaymentTransactionItem } from '@/services/payment.service';

export type PaymentTransactionStatusKind = 'success' | 'fail';

export function getPaymentTransactionStatusKind(item: PaymentTransactionItem): PaymentTransactionStatusKind {
  return item.successful ? 'success' : 'fail';
}

const DATE_FORMAT = 'yyyy-MM-dd HH:mm:ss';

export function parsePaymentDate(startDate: string): Date | null {
  const d = parse(startDate.trim(), DATE_FORMAT, new Date());
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatPaymentTransactionDateTime(date: string): string {
  const d = parsePaymentDate(date);
  if (!d) return date;
  return format(d, 'yyyy/MM/dd HH:mm');
}

export function formatPaymentTransactionSubtitle(date: string): string {
  const d = parsePaymentDate(date);
  if (!d) return '';
  return format(d, 'EEEE، d MMMM yyyy', { locale: faIR });
}
